import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { API } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";
import { InfoCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";

type Props = {
    history: {
        push: Function,
    },
}
const SetupWalletPin = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPin, setConfirmPin] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(false);

    const { handleSubmit, errors, control } = useForm();
    const onSubmit = async (data) => {
        setPasswordMatch(false);
        if (data.newpin === data.confirmpin) {
            try {
                const response = await API.post('/rewards/wallet-pin',
                { pin: btoa(data?.confirmpin) },
                {
                headers: {
                    'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
                },
                }
                );
                if (response?.data.responseCode === 200) {
                    props.history.replace(`/rtp-otp-verification?currentWalletPinGid=${response?.data?.entity?.gid}`);
                    notification.info({
                        className: "alert alert-success",
                        icon: <div className="d-flex align-items-center gap-8">
                        <InfoCircleOutlined style={{ fontSize: '20px' }} />
                        <span style={{ fontSize: '15px' }}>PIN setup completed!</span>
                        </div>,
                        duration: 4,
                    })
                }
            } catch (e) {
                setShowErrorMessage(true);
                setErrorMessage(e && e.data ? e?.data?.message : 'Unable to process request. Please try again later');
            }
        } else if (data.newpin !== data.confirmpin) {
            setPasswordMatch(true);
        }
        
    };

    const customInputStyle = {
        background: 'white',
        borderColor: '#CCCCCC',
        width: '90%',
        height: '41px',
        paddingLeft: '15px',
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <H1Text>
                            Wallet Pin
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        WALLET PIN SETUP
                    </H1Text>
                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Setup Wallet Pin
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                Enter Pin
                           </LabelText>
                            <InputWrapper style={{ borderColor: '#CCCCCC' }} marginBottom="0px" borderRadius="4px" width='298px'>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.newpin ? "red" : "inherit"}
                                    border="0px !important"
                                    name="newpin"
                                    placeholder="Enter Pin"
                                    rules={{
                                        required: 'Pin is required',
                                        pattern: {
                                            value: /^[a-zA-Z0-9]{6}$/,
                                            message: 'Pin must be exactly 6 digits'
                                        }
                                    }}
                                    as={<Input
                                        style={customInputStyle}
                                        type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("newpin")} />}
                                />
                                <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="newpin"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                Confirm Pin
                           </LabelText>
                            <InputWrapper style={{ borderColor: '#CCCCCC' }} marginBottom="0px" borderRadius="4px" width='298px'>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.confirmpin ? "red" : "inherit"}
                                    border="0px !important"
                                    name="confirmpin"
                                    placeholder="Confirm New Pin"
                                    rules={{
                                        required: 'Confirm Pin is required',
                                        pattern: {
                                            value: /^[a-zA-Z0-9]{6}$/,
                                            message: 'Pin must be exactly 6 digits'
                                        }
                                    }}
                                    as={<Input style={customInputStyle}
                                        type={confirmPin ? "text" : "password"} readOnly={readOnly && readOnly.includes("confirmpin")} />}
                                />
                                <Img verticalAlign='middle' onClick={() => setConfirmPin(!confirmPin)} src={confirmPin ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="confirmpin"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            {passwordMatch && <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Pin and Confirm Pin should match</Text>}
                            <div>
                                <SubmitButton
                                    style={{ width: '292px' }}
                                    type="submit"
                                >Confirm</SubmitButton>
                            </div>
                            {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                        </form>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default SetupWalletPin;
